import {
  GetExpectedDPMOChangeEventsOutput,
  GetWeeklySqprSummariesOutput,
  GetQualityEventsOutput,
  GetSQPRQualityErrorsOutput,
  GetQualityReportOutput,
  GetUnknownIdleTimeMetricsOutput,
} from '../types/backendService';
import moment from 'moment';
import {getPerformanceWeekStart} from "src/util/date_time_utils";

export const getQualityErrorsStub = (): GetSQPRQualityErrorsOutput => {
  return {
    sqprQualityErrors: [
      {
        errorType: 'Overage',
        expectedDpmo: 1100.0,
        isErrorTypeExcluded: false,
        lcFamilyId: 'Stow',
        metricTime: 1657108800,
        minimumUnits: 1000,
        qualityEvents: 1,
        unitsProcessed: 7169,
        warehouseId: 'PHX6',
        qualityEventIds: ['1', '2', '3'],
      },
    ],
  };
};

export const getQualityEventsStub = (): GetQualityEventsOutput => {
  return {
    qualityEvents: [
      {
        createdBy: 'aft-ps',
        enteredTime: 1657234381,
        errorInfo: {
          'Application Name': 'AFTWatsonService',
          'Location Id': 'tsX078ntmrz',
          'Raw Error Type': 'Overage',
          'Reported In Process Path': 'Stow',
        },
        errorType: 'Overage',
        isUsedInSQPR: true,
        learningCurveFamily: 'Stow',
        metricTime: 1657206301,
        source: 'MORIARTY',
        warehouseId: 'PHX6',
        id: '1',
      },
      {
        createdBy: 'aft-ps',
        enteredTime: 1657235381,
        errorInfo: {
          'Application Name': 'AFTWatsonService',
          'Location Id': 'tsX012hseyh',
          'Raw Error Type': 'Shortage',
          'Reported In Process Path': 'Stow',
        },
        errorType: 'Shortage',
        isUsedInSQPR: true,
        learningCurveFamily: 'Stow',
        metricTime: 1657207245,
        source: 'MORIARTY',
        warehouseId: 'PHX6',
        id: '5',
      },
    ],
  };
};

export const getSqprSummariesStub = (): GetWeeklySqprSummariesOutput => {
  const now = moment().startOf('hour');
  const lastSqprPeriodEnd = now
    .subtract(3, 'days')
    .startOf('week')
    .add(3, 'days');

  return {
    summaries: [
      {
        currentDPMO: 204.20665713702266,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(13, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(14, 'weeks')
          .unix(),
        percentile: 66.55231475830078,
        performance: 56.43575844208885,
        qualityEvents: 1,
        rank: 776,
        totalPopulation: 1166,
        units: 4897,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'TopPerformer',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(12, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(13, 'weeks')
          .unix(),
        percentile: 2.4096386432647705,
        performance: 73.0,
        qualityEvents: 0,
        rank: 28,
        totalPopulation: 1162,
        units: 5788,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 254.51768897938408,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(11, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(12, 'weeks')
          .unix(),
        percentile: 71.39107513427734,
        performance: 63.86202827460144,
        qualityEvents: 1,
        rank: 816,
        totalPopulation: 1143,
        units: 3929,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 622.0839813374805,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(10, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(11, 'weeks')
          .unix(),
        percentile: 79.92599487304688,
        performance: 95.44691078750177,
        qualityEvents: 2,
        rank: 864,
        totalPopulation: 1081,
        units: 3215,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 204.20665713702266,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(9, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(10, 'weeks')
          .unix(),
        percentile: 66.55231475830078,
        performance: 81.43575844208885,
        qualityEvents: 1,
        rank: 776,
        totalPopulation: 1166,
        units: 4897,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'TopPerformer',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(8, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(9, 'weeks')
          .unix(),
        percentile: 2.4096386432647705,
        performance: 100.0,
        qualityEvents: 0,
        rank: 28,
        totalPopulation: 1162,
        units: 5788,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 254.51768897938408,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(7, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(8, 'weeks')
          .unix(),
        percentile: 71.39107513427734,
        performance: 76.86202827460144,
        qualityEvents: 1,
        rank: 816,
        totalPopulation: 1143,
        units: 3929,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 622.0839813374805,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(6, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(7, 'weeks')
          .unix(),
        percentile: 79.92599487304688,
        performance: 43.44691078750177,
        qualityEvents: 2,
        rank: 864,
        totalPopulation: 1081,
        units: 3215,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'TopPerformer',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(5, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(6, 'weeks')
          .unix(),
        percentile: 1.6901408433914185,
        performance: 100.0,
        qualityEvents: 0,
        rank: 18,
        totalPopulation: 1065,
        units: 5938,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 489.7959183673469,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(4, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(5, 'weeks')
          .unix(),
        percentile: 78.01094818115234,
        performance: 55.473098330241186,
        qualityEvents: 3,
        rank: 855,
        totalPopulation: 1096,
        units: 6125,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(4, 'weeks')
          .unix(),
        percentile: 13.376383781433105,
        performance: 100.0,
        qualityEvents: 0,
        rank: 145,
        totalPopulation: 1084,
        units: 3401,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 139.48946854512485,
        employeeStanding: 'MetExpectations',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        percentile: 64.20454406738281,
        performance: 87.31913922317047,
        qualityEvents: 1,
        rank: 678,
        totalPopulation: 1056,
        units: 7169,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'TopPerformer',
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(1, 'week')
          .unix(),
        expectedDPMO: 1100.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        percentile: 0.8936550617218018,
        performance: 100.0,
        qualityEvents: 0,
        rank: 10,
        totalPopulation: 1119,
        units: 8802,
        warehouseId: 'PHX6',
      },
      {
        currentDPMO: 0.0,
        employeeStanding: 'TopPerformer',
        endTime: lastSqprPeriodEnd.clone().unix(),
        expectedDPMO: 774.0,
        metricTime: lastSqprPeriodEnd
          .clone()
          .subtract(1, 'week')
          .unix(),
        percentile: 7.1358747482299805,
        performance: 100.0,
        qualityEvents: 0,
        rank: 73,
        totalPopulation: 1023,
        units: 4718,
        warehouseId: 'PHX6',
      },
    ],
  };
};

export const getQualityReportStub = (): GetQualityReportOutput => {
  return {
    qualityReportItems: [
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 450.0,
        percentToPeers: 54.23728942871094,
        periodStart: getPerformanceWeekStart().unix(),
        unitsProcessed: 441,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 450.0,
        percentToPeers: 46.386192321777344,
        periodStart: getPerformanceWeekStart().unix(),
        unitsProcessed: 684,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 494.0,
        percentToPeers: 33.47064971923828,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 1 }).unix(),
        unitsProcessed: 1463,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Pick',
        errors: 0,
        expectedDpmo: 202.0,
        percentToPeers: 80.79331970214844,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 4 }).unix(),
        unitsProcessed: 984,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 494.0,
        percentToPeers: 80.79331970214844,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 5 }).unix(),
        unitsProcessed: 1098,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 494.0,
        percentToPeers: 35.87196350097656,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 5 }).unix(),
        unitsProcessed: 193,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 494.0,
        percentToPeers: 9.050772666931152,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 6 }).unix(),
        unitsProcessed: 1412,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Pick',
        errors: 0,
        expectedDpmo: 202.0,
        percentToPeers: 36.748329162597656,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 9 }).unix(),
        unitsProcessed: 1443,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 494.0,
        percentToPeers: 36.748329162597656,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 10 }).unix(),
        unitsProcessed: 1905,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 244.0,
        percentToPeers: 58.032379150390625,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 11 }).unix(),
        unitsProcessed: 170,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 244.0,
        percentToPeers: 48.933502197265625,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 11 }).unix(),
        unitsProcessed: 309,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Pick',
        errors: 0,
        expectedDpmo: 202.0,
        percentToPeers: 39.655174255371094,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 12 }).unix(),
        unitsProcessed: 2821,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 244.0,
        percentToPeers: 39.655174255371094,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 14 }).unix(),
        unitsProcessed: 172,
      },
      {
        dpmo: 0.0,
        errorFamily: 'Stow',
        errors: 0,
        expectedDpmo: 244.0,
        percentToPeers: 56.94956970214844,
        periodStart: getPerformanceWeekStart().subtract({ weeks: 15 }).unix(),
        unitsProcessed: 244,
      },
    ],
  };
};

export const getExpectedDPMOChangeEventsStub = (): GetExpectedDPMOChangeEventsOutput => {
  const now = moment().startOf('hour');
  const lastSqprPeriodEnd = now
    .subtract(3, 'days')
    .startOf('week')
    .add(3, 'days');

  return {
    expectedDPMOChangeEvents: [
      {
        startTime: lastSqprPeriodEnd
          .clone()
          .subtract(1, 'weeks')
          .unix(),
        endTime: lastSqprPeriodEnd
          .clone()
          .unix(),
        errorFamily: "Pick",
        dpmo: 1100.0,
      },
      {
        startTime: lastSqprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(1, 'weeks')
          .unix(),
        errorFamily: "Pick",
        dpmo: 980.0,
      },
      {
        startTime: lastSqprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(2, 'weeks')
          .unix(),
        errorFamily: "Pick",
        dpmo: 1100.0,
      },
      {
        startTime: lastSqprPeriodEnd
          .clone()
          .subtract(4, 'weeks')
          .unix(),
        endTime: lastSqprPeriodEnd
          .clone()
          .subtract(3, 'weeks')
          .unix(),
        errorFamily: "Pick",
        dpmo: 1100.0,
      },
    ],
  };
};
